import { useInstanceKey } from "app/area/favourite/favourite-context";
import { useCallback } from "react";
import { useActionCreators } from "app/area/case-report/case-listing/hooks";
import { useSelector } from "react-redux";
import { selectCasePermissions } from "app/area/case-report/case-listing/selectors";

export function caseTableViewPermissionHook(caseId: number) {
  const {
    getPermissions
  } = useActionCreators();
  const instanceKey = useInstanceKey();
  const permissions = useSelector(selectCasePermissions(instanceKey, caseId));

  const loadPermissions = useCallback((caseNumber: number) => {
    getPermissions([caseNumber]);
  }, [getPermissions, instanceKey]);

  return {
    loadPermissions,
    permissions
  };
}

